





























































import { Vue, Component, Prop } from 'vue-property-decorator'
import { TaiwanEnroll } from '@/models/enroll/taiwanStudent'
import { ConfigStore } from './config'

import InfomationForm from './InfomationForm.vue'
import ApplicationForm from './ApplicationForm.vue'
import EducationForm from './EducationForm.vue'
import ReportForm from './ReportForm.vue'
import AwardForm from './AwardForm.vue'
import ActivitiesForm from './ActivitiesForm.vue'
import FamilyForm from './FamilyForm.vue'
import IntroduceForm from './IntroduceForm.vue'

@Component({
  components: {
    InfomationForm,
    ApplicationForm,
    EducationForm,
    ReportForm,
    AwardForm,
    ActivitiesForm,
    FamilyForm,
    IntroduceForm
  }
})
export default class TaiwanStudentDetail extends Vue {
  @Prop({ required: true }) value!: TaiwanEnroll

  print = true
  title = this.config.title

  date = ''
  dateTimer = -1

  get config() {
    return (
      ConfigStore.configs.find(a => a.key === 'taiwan-student') || { value: {} }
    ).value
  }

  get remarks() {
    return (this.config.details as string[]).flat(1)
  }

  mounted() {
    const timerHandler = () => {
      const date = new Date()
      this.date = '$year 年 $month 月 $day 日'
        .replace('$year', date.getFullYear().toString())
        .replace('$month', (date.getMonth() + 1).toString())
        .replace('$day', date.getDate().toString())
    }

    timerHandler()
    const timer = setInterval(timerHandler, 1000)
    this.dateTimer = (timer as unknown) as number
  }

  unmounted() {
    clearInterval(this.dateTimer)
  }
}
